import React from 'react';
import i18n from 'utils/i18n';
import { Input } from 'semantic-ui-react';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Molecule AddressPickers
 * 
 * Just a picker that can be used to show or trigger the edit of addresses.
 */
function AddressPickers (props) {
  // const gt = i18n.useTranslations('global');
  const t = i18n.useTranslations('modules.AddressPicker');

  const {
    className = "",
    children,
    onClick,
    editable,
    required,
    address:addessProp,
    value,
    readOnly,
    apis,
    busy,
    label,
    onDone,
    onCancel,
    ...other
  } = props;

  const {
    street,
    number,
    // complement,
    // neighborhood,
    city,
    state,
    uf,
    // coordLat,
    // coordLng,
  } = (value || {});

  let addr = street || '';
  if (number) {
    addr += ', ' + number;
  }

  if (city) {
    addr += ', ' + city;
  }

  if (uf || state) {
    addr += ' / ' + (uf || state);
  }

  return <div
    className={`${css["molecule__address-pickers-container"]} ${className}`}
    {...other}
  >
    <div className="field">
      <label>{label}{required ? '*' : ''}</label>
      <Input
        // fluid
        // iconPosition='left'
        required={required}
        readOnly={readOnly}
        label={
          editable && {
            as: 'button',
            type: 'button',
            tag: true,
            content: addessProp ? t('Change address') : t('Add address'),
            onClick: event => {
              apis.window.spawn(
                'AddressPicker',
                {
                  readOnly: readOnly,
                  doneLabel: "OK",
                  cancelLabel: 'Cancel',
                  onDone,
                  onCancel,
                  defaultAddress: value
                },
                { tied: true }
              );
              // event.stopPropagation();
              // event.preventDefault();
            },
            style:{cursor: 'pointer'},
            tabIndex: 0
          }
        }
        labelPosition='right'
        placeholder=''
        value={addr}
        readOnlly
      />
    </div>
  </div>;
}

export default AddressPickers;
